module.exports = __webpack_public_path__ + "static/energy_13-96856c499ca5ac1821a81228d315bf01.jpg";